import { ActivityLogTable } from "Dashboard/Components/ActivityLogTable";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const ActivityLogPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout title={t(Resources.Common.ActivityLog)}>
      <ActivityLogTable />
    </AuthenticatedLayout>
  );
};
